/* eslint-disable implicit-arrow-linebreak */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: 'shopEdit',
    name: 'shopEdit',
    meta: {
      title: '编辑'
    },
    component: () => import(/* webpackChunkName: "pop-shopDetail" */ '../views/shopBaseInfo/shopBaseInfo-edit.vue')
  },
  {
    path: 'shopInfo',
    name: 'shopInfo',
    meta: {
      title: '店铺基础信息查看'
    },
    component: () => import(/* webpackChunkName: "pop-shopInfo" */ '../views/shopBaseInfo/index.vue')
  },
  {
    path: 'contractManagement',
    name: 'contractManagement',
    meta: {
      title: '合同管理'
    },
    component: () => import(/* webpackChunkName: "pop-contractManagement" */ '../views/contractManagement/index.vue')
  },
  {
    path: 'merchantsCollege',
    name: 'merchantsCollege',
    meta: {
      title: '商家学院'
    },
    component: () => import(/* webpackChunkName: "pop-contractManagement" */ '../views/merchantsCollege/index.vue')
  },
  {
    path: 'financialEdit',
    name: 'financialEdit',
    meta: {
      title: '财务信息编辑'
    },
    component: () => import(/* webpackChunkName: "pop-financialEdit" */ '../views/financialInfo/financialInfo-edit.vue')
  },
  {
    path: 'financialInfo',
    name: 'financialInfo',
    meta: {
      title: '财务信息查看'
    },
    component: () => import(/* webpackChunkName: "pop-financialInfo" */ '../views/financialInfo/index.vue')
  },
  {
    path: 'weChatAccountOpen',
    name: 'WeChatAccountOpen',
    meta: { title: '微信账户开户' },
    component: () => import(/* webpackChunkName: "pop-depositInfo" */ '../views/weChatAccountOpen/index.vue')
  },
  {
    path: 'depositInfo',
    name: 'depositInfo',
    meta: {
      title: '保证金'
    },
    component: () => import(/* webpackChunkName: "pop-depositInfo" */ '../views/cashDepositInfo/index.vue')
  },
  {
    path: 'settlement',
    name: 'settlement',
    meta: {
      title: '商家结算管理'
    },
    component: () => import(/* webpackChunkName: "pop-depositInfo" */ '../views/settlement/index.vue')
  },
  {
    path: 'returnAddressInfo',
    name: 'returnAddressInfo',
    meta: {
      title: '退货地址查看'
    },
    component: () => import(/* webpackChunkName: "pop-returnAddressInfo" */ '../views/returnAddress/index.vue')
  },
  {
    path: 'returnAddressEdit',
    name: 'returnAddressEdit',
    meta: {
      title: '退货地址编辑'
    },
    component: () =>
      import(/* webpackChunkName: "pop-returnAddressEdit" */ '../views/returnAddress/returnAddress-edit.vue')
  },
  {
    path: 'supplementaryPay',
    name: 'supplementaryPay',
    meta: {
      title: '保证金补缴'
    },
    component: () =>
      import(/* webpackChunkName: "pop-returnAddressEdit" */ '../views/cashDepositInfo/supplementaryPay.vue')
  },

  {
    path: 'buyerFreight',
    name: 'buyerFreight',
    meta: {
      title: '运费模板'
    },
    component: () => import(/* webpackChunkName: "pop-buyerFreight" */ '../views/buyerFreight/index.vue')
  },
  {
    path: 'buyerFreightForm',
    name: 'buyerFreightForm',
    meta: {
      title: '新增、编辑运费模板'
    },
    component: () =>
      import(/* webpackChunkName: "pop-buyerFreightForm" */ '../views/buyerFreight/buyerFreight-form.vue')
  },
  {
    path: 'receiptOrder',
    name: 'receiptOrder',
    meta: {
      title: '电子收据'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/receiptManagement/index.vue')
  },
  {
    path: 'softKey',
    name: 'softKey',
    meta: {
      title: '电子签章'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/softKey/index.vue')
  },
  {
    path: 'internalMessage',
    name: 'internalMessage',
    meta: {
      title: '站内信'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/internalMessage/index.vue')
  },
  {
    path: 'messageDetail',
    name: 'messageDetail',
    meta: {
      title: '详情'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/internalMessage/messageDetail.vue')
  },
  {
    path: 'needCenter',
    name: 'needCenter',
    meta: {
      title: '待办中心'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/needCenter/index.vue')
  },
  {
    path: 'bondedWarehouse',
    name: 'bondedWarehouse',
    meta: {
      title: '保税认证仓'
    },
    component: () => import(/* webpackChunkName: "pop-receiptOrder" */ '../views/baseInfo/bondedWarehouseList.vue')
  },
  {
    path: 'bondedWarehouseForm',
    name: 'bondedWarehouseForm',
    meta: {
      title: '新增或编辑'
    },
    component: () =>
      import(/* webpackChunkName: "pop-buyerFreightForm" */ '../views/baseInfo/components/bondedWarehouse-form.vue')
  },
]
